import { render, staticRenderFns } from "./AddressOptional.vue?vue&type=template&id=0fbfb60c"
import script from "./AddressOptional.vue?vue&type=script&lang=js"
export * from "./AddressOptional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fbfb60c')) {
      api.createRecord('0fbfb60c', component.options)
    } else {
      api.reload('0fbfb60c', component.options)
    }
    module.hot.accept("./AddressOptional.vue?vue&type=template&id=0fbfb60c", function () {
      api.rerender('0fbfb60c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/invoices/components/AddressOptional.vue"
export default component.exports